import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_DELETE_FOR_DISCOUNT_LIST_MUTATION = graphql(/* GraphQL */ `
	mutation discountDeleteForDiscountListDelete($hotelID: ID!, $discountId: ID!) {
		discountDelete(hotelID: $hotelID, discountID: $discountId) {
			userErrors
			message
		}
	}
`);
